<script setup lang="ts">
import type { IntRange } from 'type-fest'

const { t } = useI18n()

function getStaticAsset(index: StringifiedInt<IntRange<0, 3>>) {
  const value = match(index)
    .with('0', () => 'dkkgimq1ky.jpg')
    .with('1', () => '7ht22dix3v.jpg')
    .with('2', () => 'om3k3a53iz.jpg')
    .exhaustive()

  return `${S3_ASSETS_URL}/careers/team/${value}`
}
</script>

<template>
  <div class="flex flex-col items-center justify-center">
    <div class="text-2xl font-normal">
      {{ t("careers.section.join_team.header_sm") }}
    </div>

    <div class="mb-12 text-4xl font-medium lg:text-5xl">
      {{ t("careers.section.join_team.header") }}
    </div>

    <div class="grid w-full grid-cols-4 gap-2 lg:gap-4">
      <div
        v-for="index in ['0', '1', '2'] as const"
        :key="index"
        :class="{
          'order-1 col-span-2 lg:col-span-1': index === '0',
          'order-3 col-span-4 lg:order-2 lg:col-span-2': index === '1',
          'order-2 col-span-2 lg:col-span-1': index === '2',
        }"
      >
        <img
          :src="getStaticAsset(index)"
          class="aspect-square size-full max-h-80 rounded-[2rem] object-cover object-center"
          role="presentation"
        >
      </div>
    </div>
  </div>
</template>
